import { Navigate, Route, Routes } from 'react-router-dom';
import { TransformationCenterPage } from './TransformationCenterPage';
import { ManageTransformationsPage } from './ManageTransformationsPage';
import type { UnicornApi } from '@cld/unicorn-api';

export const TransformationsRouting = ({
  navigateOutsideApplication,
  unicornApi,
}: {
  unicornApi: UnicornApi;
  navigateOutsideApplication(path: string): void;
}) => {
  return (
    <Routes>
      <Route path="center/*" element={<TransformationCenterPage unicornApi={unicornApi} />} />
      <Route path="manage/*" element={<ManageTransformationsPage unicornApi={unicornApi} navigateOutsideApplication={navigateOutsideApplication} />} />
      <Route path="*" element={<Navigate to="center" replace />} />
    </Routes>
  );
};
